import { LogOut } from 'lucide-preact';
import { ComponentProps } from 'preact';

import AppStoreDownloadButton from '@/components/AppStoreDownloadButton';
import { useLogout } from '@/components/Authorize/hooks';
import { PrimaryButton } from '@/components/Buttons';
import SocialNetworkList from '@/components/SocialNetworkList';
import route from '@/lib/route';
import { cn } from '@/lib/utils';
import { useSelector } from '@/redux/helper';
import { selectIsFreeUser } from '@/redux/selectors/users';

interface NavMenuFooterProps extends ComponentProps<'div'> {
  hideUpgradeButton?: boolean;
  onItemClick?: () => void;
}

const NavMenuFooter = ({ hideUpgradeButton, onItemClick, className, ...props }: NavMenuFooterProps) => {
  const username = useSelector((store) => store.user.username);
  const logoutHandler = useLogout();
  const isLoggedIn = !!username;
  const isFreeUser = useSelector(selectIsFreeUser);

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <div className={cn('flex flex-col items-center justify-center gap-6', className)} {...props}>
      {!isLoggedIn ? (
        <>
          <AppStoreDownloadButton className="w-full max-w-40" />
          <div className="w-full px-6">
            <SocialNetworkList className="w-full max-w-64" />
          </div>
          <div className="w-full px-6">
            <PrimaryButton
              className="w-full"
              label="Sign Up"
              size="large"
              onClick={() => {
                route('/signup');
                onItemClick?.();
              }}
            />
          </div>
          <a href="/login" className="preflight preflight-a text-base font-bold text-stone-500">
            Log In
          </a>
        </>
      ) : (
        <>
          {isFreeUser && !hideUpgradeButton && (
            <div className="w-full px-6">
              <PrimaryButton
                className="w-full"
                label="Upgrade"
                size="large"
                onClick={() => {
                  route('/plans');
                  onItemClick?.();
                }}
              />
            </div>
          )}
          <button
            type="button"
            onClick={logoutHandler}
            className="preflight preflight-button flex w-full items-center justify-center gap-2 px-6 py-3 text-base font-bold text-stone-500 hover:bg-[#ebebeb] hover:text-stone-900"
          >
            <LogOut className="size-5" />
            Log Out
          </button>
        </>
      )}
    </div>
  );
};
export default NavMenuFooter;
